module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-23-2c6d43d64d4714b54a6d252ffd07e0f3.png";